import React, { useState } from "react";
import { Layout, Menu, Breadcrumb } from "antd";

const { Content, Sider } = Layout;

const graphs = [
  { id: "graph1", 
    title: "Evolución en el tiempo", 
    menuTitle: "Evolución en el tiempo", 
    text: `Las defunciones neonatales han mostrado una tendencia general a la baja, pasando de 1.283 en 2010 a 788 en 2021. 
    Esto representa una disminución significativa en la tasa de defunciones neonatales, de 5,12 a 4,45. Similar a las defunciones neonatales, 
    las muertes de menores de un año han disminuido, de 1.862 en 2010 a 1.028 en 2021. 
    La tasa de mortalidad infantil ha bajado de 7,43 a 5,80 en el mismo período.`, 
    link: "https://public.flourish.studio/visualisation/20167667/embed"},

  { id: "graph2", 
    title: "Análisis por sexo", 
    menuTitle: "\u2022 Sexo", 
    text: `Se observa en todos los años de estimación que hay más niños que niñas fallecidos, tanto entre las y los neonatos como entre las y los menores de 1 año. 
    En 2021, sin embargo, esta brecha se acercó, llegando a representar cada sexo  a un 50% de las muertes. `, 
    link: "https://public.flourish.studio/visualisation/20281489/embed"},

  { id: "graph3", 
    title: "Análisis por edad de la madre", 
    menuTitle: "\u2022 Edad madre", 
    text: `La mayoría de las defunciones neonatales se presentan en madres de 30 a 34 años. 
    En cuanto a la edad de las madres de los niños fallecidos menores de 1 año, la distribución es similar, 
    en tanto las madres de 30 a 34 años representan la mayor proporción.`, 
    link: "https://public.flourish.studio/visualisation/20205166/embed"},

  { id: "graph4", 
    title: "Análisis por causa de la muerte", 
    menuTitle: "\u2022 Causa muerte", 
    text: `En cuanto a las causas de muertes en menores de 1 año, el 50% de ellas se produce por ciertas afecciones originadas en el período perinatal. 
    Otro porcentaje significativo lo constituyen las malformaciones congénitas (39%). 
    Para las y los neonatos que fallecieron, no podemos conocer sus causas de muerte. `, 
    link: "https://public.flourish.studio/visualisation/20280755/embed"},

  { id: "graph5", 
    title: "Región", 
    menuTitle: "\u2022 Región", 
    text: `Si bien hay tendencia nacional a la baja en la tasa de la mortalidad neonatal en la última década, no en todas las regiones se observa esta disminución. 
    En Coquimbo, Biobío, Los Ríos, Los Lagos, Aysén y Magallanes desde el 2010 la tasa ha aumentado. 
    La región Metropolitana es la que presenta la mayor cantidad de defunciones neonatales (305 en 2021) y la región de Aysén la que tiene una mayor tasa (7,1). 
    En cuanto a las defunciones de menores de un año, también hay regiones que presentan un aumento, contrario a la tendencia nacional: 
    en Coquimbo, Los Ríos y Aysén hay una tasa mayor de niñas y niños menores de un año que han fallecido. 
    La región Metropolitana es nuevamente la que tiene una mayor cantidad de niñas y niños fallecidos (401) y Magallanes es la que tiene una mayor tasa en 2021 (8,7).`, 
    link: "https://public.flourish.studio/visualisation/20279093/embed"},

  { id: "graph6", 
    title: "Conclusiones", 
    menuTitle: "Conclusiones", 
    text: `La disminución de la mortalidad neonatal e infantil podría indicar mejoras en la atención y salud materno-infantil en Chile. 
    No obstante, las diferencias entre regiones sugieren que aún existen áreas que requieren atención especial para reducir las tasas de mortalidad. 
    Las principales causas de muerte en menores de un año reflejan la importancia de fortalecer la atención prenatal y los servicios de salud, 
    permitiendo detectar y tratar condiciones de riesgo desde el embarazo.`, 
    link: ""},

];

const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("graph1");

  const handleMenuItemClick = (graphId, graphTitle) => {
    setSelectedMenuItem(graphId);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const selectedGraph = graphs.find((graph) => graph.id === selectedMenuItem);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={250}
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapsed}
        style={{ background: "#fff" }}
        breakpoint="lg"
        collapsedWidth={0}
      >
        <Menu theme="dark" mode="vertical" selectedKeys={[selectedMenuItem]} style={{ background: "#fff" }}>
          {graphs.map((graph) => (
            <Menu.Item
              key={graph.id}
              onClick={() => handleMenuItemClick(graph.id)}
              style={{ color: 'black', paddingLeft: graph.id !== "graph1" ? "30px" : "20px" }}
            >
              {graph.menuTitle}
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout style={{ padding: "24px 24px 24px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item></Breadcrumb.Item>
        </Breadcrumb>
        <Content
          id="content"
          style={{
            background: "#ffff",
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          {selectedGraph && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <h1>{selectedGraph.title}</h1>
              </div>
              <div>{selectedGraph.text}</div>
              <iframe
                src={selectedGraph.link}
                frameBorder="0"
                scrolling="no"
                style={{ minWidth: "100%", height: "500px" }}
              ></iframe>
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;

